import {
  AnatomyCuriosity,
  AnatomyExperts,
  AnatomyFeelings,
  AnatomySatisfied,
  AnatomySense,
  BodySecrets,
  BrainNervousSystem,
  BrainPain,
  CuriosityInterstitial,
  DailyGoalAnatomy,
  DigestiveSystem,
  DistractionsAnatomy,
  EmailAnatomy,
  ExcellentKnowledge,
  FootBiomechanics,
  GoalsAnatomy,
  GrowthPlanAnatomy,
  IntroAnatomy,
  KidneysFiltration,
  KindOfLearningAnatomy,
  LearnAnatomy,
  LearningProfileAnatomy,
  MotivationAnatomy,
  OrganRegenerates,
  PelvicFloor,
  PreparePlanAnatomyPage,
  ProofGraphAnatomy,
  RatingsAnatomy,
  RecommendationAnatomy,
  ScratchAnatomy,
  SimplifiedAnatomy,
  SmallestBone,
  SocialProofAnatomy,
  SpecificReasonAnatomy,
  StatementAnatomy,
  StrongestMuscle,
  TopicsAnatomy,
} from '~/pages/anatomy'
import AgeAnatomyV2 from '~/pages/anatomyV2/age'
import AnatomyNetworkAnatomyV2 from '~/pages/anatomyV2/anatomyNetwork'
import BodyPartsAnatomyV2 from '~/pages/anatomyV2/bodyParts'
import DiagnosisHeadacheAnatomyV2 from '~/pages/anatomyV2/diagnosisHeadache'
import DiagnosisHipAnatomyV2 from '~/pages/anatomyV2/diagnosisHip'
import DiagnosisShoulderAnatomyV2 from '~/pages/anatomyV2/diagnosisShoulder'
import DoomscrollingTimeAnatomyV2 from '~/pages/anatomyV2/doomscrollingTime'
import FocusAbilityAnatomyV2 from '~/pages/anatomyV2/focusAbility'
import FocusGoalAnatomyV2 from '~/pages/anatomyV2/focusGoal'
import FocusRevealAnatomyV2 from '~/pages/anatomyV2/focusReveal'
import GenderAnatomyV2 from '~/pages/anatomyV2/gender'
import HipFlexorAnatomyV2 from '~/pages/anatomyV2/hipFlexor'
import IntroAnatomyV2 from '~/pages/anatomyV2/intro'
import KindOfLearningAnatomyV2 from '~/pages/anatomyV2/kindOfLearning'
import LearningProfileAnatomyV2 from '~/pages/anatomyV2/learningProfile'
import LowerBackPainAnatomyV2 from '~/pages/anatomyV2/lowerBackPain'
import NeckStrainAnatomyV2 from '~/pages/anatomyV2/neckStrain'
import OrganRegeneratesAnatomyV2 from '~/pages/anatomyV2/organRegenerates'
import PostureInfluenceAnatomyV2 from '~/pages/anatomyV2/postureInfluence'
import QlMuscleRevealAnatomyV2 from '~/pages/anatomyV2/qlMuscleReveal'
import QuickExperimentAnatomyV2 from '~/pages/anatomyV2/quickExperiment'
import RateYourselfAnatomyV2 from '~/pages/anatomyV2/rateYourself'
import Section2CompleteAnatomyV2 from '~/pages/anatomyV2/section2Complete'
import Section3CompleteAnatomyV2 from '~/pages/anatomyV2/section3Complete'
import Section4CompleteAnatomyV2 from '~/pages/anatomyV2/section4Complete'
import Section5CompleteAnatomyV2 from '~/pages/anatomyV2/section5Complete'
import ShoulderPainAnatomyV2 from '~/pages/anatomyV2/shoulderPain'
import SmallestBoneAnatomyV2 from '~/pages/anatomyV2/smallestBone'
import SocialProofAnatomyV2 from '~/pages/anatomyV2/socialProof'
import SpecificReasonAnatomyV2 from '~/pages/anatomyV2/specificReason'
import SpinePostureAnatomyV2 from '~/pages/anatomyV2/spinePosture'
import SpotTheFakeAnatomyV2 from '~/pages/anatomyV2/spotTheFake'
import StrongestMuscleAnatomyV2 from '~/pages/anatomyV2/strongestMuscle'
import VagusNerveAnatomyV2 from '~/pages/anatomyV2/vagusNerve'
import WaterDigestionAnatomyV2 from '~/pages/anatomyV2/waterDigestion'
import WhatWeExploredAnatomyV2 from '~/pages/anatomyV2/whatWeExplored'
import YoureNotAloneAnatomyV2 from '~/pages/anatomyV2/youreNotAlone'
import MonaLisaArt from '~/pages/art/factCard/monaLisa'
import TheScreamArt from '~/pages/art/factCard/theScream'
import VanGoghEarArt from '~/pages/art/factCard/vanGoghEar'
import GoodCompanyArt from '~/pages/art/goodCompany'
import InterestsSharedArt from '~/pages/art/interestsShared'
import IntroArt from '~/pages/art/intro'
import LearningIsFunArt from '~/pages/art/learningIsFun'
import KindOfLearningArt from '~/pages/art/multipleChoice/kindOfLearning'
import LearningTimeArt from '~/pages/art/multipleChoice/learningTime'
import StudyGoalArt from '~/pages/art/multipleChoice/studyGoal'
import TopicsArt from '~/pages/art/multipleChoice/topics'
import OurGoalsArt from '~/pages/art/ourGoals'
import PersonalPlanArt from '~/pages/art/personalPlan'
import DavidSculpture from '~/pages/art/quiz/davidSculpture'
import GirlPearlEarring from '~/pages/art/quiz/girlPearlEarring'
import PersistenceOfMemory from '~/pages/art/quiz/persistenceOfMemory'
import StarryNight from '~/pages/art/quiz/starryNight'
import ArtBeyondPaintings from '~/pages/art/quizBinaryChoice/artBeyondPaintings'
import FamousPaintings from '~/pages/art/quizBinaryChoice/famousPaintings'
import HiddenDetails from '~/pages/art/quizBinaryChoice/hiddenDetails'
import WowFacts from '~/pages/art/quizBinaryChoice/wowFacts'
import ArtQuizResult from '~/pages/art/quizResult'
import BestMethodArt from '~/pages/art/singleChoice/bestMethod'
import RateYourKnowledgeArt from '~/pages/art/singleChoice/rateYourKnowledge'
import StudiedBeforeArt from '~/pages/art/singleChoice/studiedBefore'
import StatementArt from '~/pages/art/statement'
import AgeCommunicationPage from '~/pages/communication/age'
import AuthorityCommunicationPage from '~/pages/communication/authority'
import AuthoritySkillsCommunicationPage from '~/pages/communication/authoritySkills'
import BeforeAfterCommunicationPage from '~/pages/communication/beforeAfter'
import CompareCommunicationPage from '~/pages/communication/compare'
import ConfidenceCommunicationPage from '~/pages/communication/confidence'
import ConstructiveFeedbackCommunicationPage from '~/pages/communication/constructiveFeedback'
import DailyGoalCommunicationPage from '~/pages/communication/dailyGoal'
import EmailCommunicationPage from '~/pages/communication/email'
import FillerWordsCommunicationPage from '~/pages/communication/fillerWords'
import GenderCommunicationPage from '~/pages/communication/gender'
import GoodCompanyCommunicationPage from '~/pages/communication/goodCompany'
import GroupConversationCommunicationPage from '~/pages/communication/groupConversation'
import HoldingBackCommunicationPage from '~/pages/communication/holdingBack'
import IntroCommunicationPage from '~/pages/communication/intro'
import LearningStyleCommunicationPage from '~/pages/communication/learningStyle'
import LightUpCommunicationPage from '~/pages/communication/lightUp'
import MotivationCommunicationPage from '~/pages/communication/motivation'
import MovingForwardCommunicationPage from '~/pages/communication/movingForward'
import PersonalityCommunicationPage from '~/pages/communication/personality'
import PlanReadyCommunicationPage from '~/pages/communication/planReady'
import PreparePlanCommunicationPage from '~/pages/communication/preparePlan'
import RatingCommunicationPage from '~/pages/communication/rating'
import ReplayCommunicationPage from '~/pages/communication/replay'
import RoleModelCommunicationPage from '~/pages/communication/roleModel'
import ScratchCommunicationPage from '~/pages/communication/scratch'
import SkillsChartCommunicationPage from '~/pages/communication/skillsChart'
import StatementCommunicationPage from '~/pages/communication/statement'
import StruggleCommunicationPage from '~/pages/communication/struggle'
import StudyGoalCommunicationPage from '~/pages/communication/studyGoal'
import Email from '~/pages/email'
import Credibility from '~/pages/general/credibility'
import CuriosityStatement from '~/pages/general/curiosityStatement'
import DailyGoal from '~/pages/general/dailyGoal'
import DoomscrollingTime from '~/pages/general/doomscrollingTime'
import EmailGeneral from '~/pages/general/email'
import FocusAbility from '~/pages/general/focusAbility'
import GoodCompanyGeneral from '~/pages/general/goodCompany'
import IntroGeneral from '~/pages/general/intro'
import KindOfLearning from '~/pages/general/kindOfLearning'
import LearningGoals from '~/pages/general/learningGoals'
import LearningObstacle from '~/pages/general/learningObstacle'
import LearningProfile from '~/pages/general/learningProfile'
import LearningStyleStatement from '~/pages/general/learningStyleStatement'
import LearningTime from '~/pages/general/learningTime'
import MatchStyle from '~/pages/general/matchStyle'
import NarrowTopics from '~/pages/general/narrowTopics'
import PacingStatement from '~/pages/general/pacingStatement'
import PreparePlan from '~/pages/general/preparePlan'
import Proof from '~/pages/general/proof'
import RatingConversations from '~/pages/general/ratingConversations'
import RatingLifelongLearning from '~/pages/general/ratingLifelongLearning'
import RatingMistakes from '~/pages/general/ratingMistakes'
import RatingProcrastination from '~/pages/general/ratingProcrastination'
import RatingVisual from '~/pages/general/ratingVisual'
import Referral from '~/pages/general/referral'
import ScreenTimeStatement from '~/pages/general/screenTimeStatement'
import SelfGrowthReason from '~/pages/general/selfGrowthReason'
import TestsFeeling from '~/pages/general/testFeeling'
import ThinkingStyle from '~/pages/general/thinkingStyle'
import TopicFact1 from '~/pages/general/topicFact1'
import TopicFact2 from '~/pages/general/topicFact2'
import TopicFact3 from '~/pages/general/topicFact3'
import TopicFact4 from '~/pages/general/topicFact4'
import Topics from '~/pages/general/topics'
import TopicsConfirmation from '~/pages/general/topicsConfirmation'
import {
  Aspects,
  AuthorName,
  BerlinWall,
  BestMethod,
  BiggestDistraction,
  Churchill,
  DiscoveryOfAmerica,
  ExcellentKnowledgeHistory,
  FriendlyPush,
  GoodCompany,
  GreatJob,
  InformationSource,
  IntroHistory,
  LearningAboutGeo,
  LearningAtSchool,
  LikeMost,
  MakingMistakes,
  Mummies,
  Osiris,
  OurGoals,
  PersonalPlan,
  PracticalSkills,
  RateYourKnowledge,
  SpecificReasonHistory,
  StayingMotivated,
  StudiedBefore,
  StudyGoal,
  TimeToLearn,
} from '~/pages/history'
import {
  BiologyExperts,
  IntroBiology,
  IntroCard,
  MultipleChoice,
  PreparePlanBiology,
  QuizBinaryChoice,
  QuizSingleChoice,
} from '~/pages/onboarding'
import UpsellPage from '~/pages/upsell'
import { PageId } from '~/shared/constants/pagesConstants'
import { TIdToPageMap } from '~/shared/types/commonTypes'

export const ID_TO_PAGE_MAP_V1: TIdToPageMap = {
  [PageId.INTRO_BIOLOGY_1]: IntroBiology,
  [PageId.INTRO_ANATOMY_1]: IntroAnatomy,
  [PageId.SOCIAL_PROOF_ANATOMY_1]: SocialProofAnatomy,
  [PageId.GOALS_ANATOMY_1]: GoalsAnatomy,
  [PageId.BY_EXPERTS_1]: BiologyExperts,
  [PageId.PREPARE_PLAN_1]: PreparePlanBiology,
  [PageId.EMAIL_1]: Email,
  [PageId.PROOF_1]: IntroCard.Goal,
  [PageId.PROOF_2]: IntroCard.Interactivity,
  [PageId.PROOF_3]: IntroCard.Discovery,
  [PageId.PROOF_4]: IntroCard.Uncover,
  [PageId.PROOF_5]: IntroCard.Knowledge,
  [PageId.PROOF_6]: IntroCard.KeepGrowing,
  [PageId.PROOF_7]: IntroCard.GoodCompany,
  [PageId.PROOF_8]: IntroCard.Graph,
  [PageId.PROOF_9]: IntroCard.NeverStopLearning,

  [PageId.HUMAN_BODY_1]: QuizBinaryChoice.HumanBody,
  [PageId.ANIMAL_WORLD_1]: QuizBinaryChoice.AnimalWorld,
  [PageId.PLANT_LIFE_1]: QuizBinaryChoice.PlantLife,
  [PageId.STUDY_1]: QuizBinaryChoice.LearnBiology,
  [PageId.LEVEL_1]: QuizBinaryChoice.BiologyLevel,
  [PageId.LEARNING_COMPLEXITY_1]: QuizBinaryChoice.LearningComplexity,
  [PageId.SKIN_1]: QuizBinaryChoice.Skin,
  [PageId.OCTOPUS_1]: QuizBinaryChoice.Octopus,
  [PageId.FROG_1]: QuizBinaryChoice.Frog,
  [PageId.FEELINGS_1]: QuizBinaryChoice.MotivatedWhileLearning,
  [PageId.RECOMMENDATION_1]: QuizBinaryChoice.Recommendation,
  [PageId.INTERSTITIAL_CURIOSITY_1]: CuriosityInterstitial,
  [PageId.ANATOMY_CURIOSITY_1]: AnatomyCuriosity,
  [PageId.FOOT_BIOMECHANICS_1]: FootBiomechanics,
  [PageId.DIGESTIVE_SYSTEM_1]: DigestiveSystem,
  [PageId.BRAIN_NERVOUS_SYSTEM_1]: BrainNervousSystem,
  [PageId.KIDNEYS_FILTRATION_1]: KidneysFiltration,
  [PageId.ANATOMY_BY_EXPERTS_1]: AnatomyExperts,
  [PageId.LEARN_ANATOMY_1]: LearnAnatomy,
  [PageId.ANATOMY_SATISFIED_1]: AnatomySatisfied,
  [PageId.ANATOMY_SENSE_1]: AnatomySense,
  [PageId.DISTRACTIONS_ANATOMY_1]: DistractionsAnatomy,
  [PageId.ANATOMY_FEELINGS_1]: AnatomyFeelings,
  [PageId.SIMPLIFIED_ANATOMY_1]: SimplifiedAnatomy,
  [PageId.PELVIC_FLOOR_1]: PelvicFloor,
  [PageId.BRAIN_PAIN_1]: BrainPain,
  [PageId.BODY_SECRETS_1]: BodySecrets,
  [PageId.STRONGEST_MUSCLE_1]: StrongestMuscle,
  [PageId.SMALLEST_BONE_1]: SmallestBone,
  [PageId.ORGAN_REGENERATES_1]: OrganRegenerates,
  [PageId.EXCELLENT_KNOWLEDGE_1]: ExcellentKnowledge,
  [PageId.MOTIVATION_ANATOMY_1]: MotivationAnatomy,
  [PageId.KIND_OF_LEARNING_ANATOMY_1]: KindOfLearningAnatomy,
  [PageId.RECOMMENDATION_ANATOMY_1]: RecommendationAnatomy,
  [PageId.GROWTH_PLAN_ANATOMY_1]: GrowthPlanAnatomy,
  [PageId.SPECIFIC_REASON_ANATOMY_1]: SpecificReasonAnatomy,
  [PageId.DAILY_GOAL_ANATOMY_1]: DailyGoalAnatomy,
  [PageId.STATEMENT_ANATOMY_1]: StatementAnatomy,
  [PageId.RATINGS_ANATOMY_1]: RatingsAnatomy,
  [PageId.TOPICS_ANATOMY_1]: TopicsAnatomy,

  [PageId.HEARTBEAT_1]: QuizSingleChoice.Heartbeat,
  [PageId.BEAR_1]: QuizSingleChoice.Bear,
  [PageId.PLANTS_GREEN_1]: QuizSingleChoice.Plant,
  [PageId.STATEMENT_1]: QuizSingleChoice.SocialMediaStatement,
  [PageId.DAILY_GOAL_1]: QuizSingleChoice.DailyGoal,
  [PageId.AGE_1]: QuizSingleChoice.Age,
  [PageId.GENDER_1]: QuizSingleChoice.Gender,

  [PageId.GAIN_1]: MultipleChoice.Gain,
  [PageId.DISTRACTION_1]: MultipleChoice.Distraction,
  [PageId.KIND_OF_LEARNING_1]: MultipleChoice.KindOfLearning,
  [PageId.SPECIFIC_REASON_1]: MultipleChoice.SpecificReason,
  [PageId.TOPICS_1]: MultipleChoice.Topic,
  [PageId.BIOLOGY_CURIOSITY_1]: MultipleChoice.BiologyCuriosity,

  [PageId.UPSELL_1]: UpsellPage,
} as const

const { [PageId.PROOF_9]: _proof9, ...anatomyBaseMap } = ID_TO_PAGE_MAP_V1

export const ANATOMY_PAGE_MAP_V1: TIdToPageMap = {
  ...anatomyBaseMap,
  [PageId.PROOF_8]: ProofGraphAnatomy,
  [PageId.LEARNING_PROFILE_ANATOMY_1]: LearningProfileAnatomy,
  [PageId.EMAIL_1]: EmailAnatomy,
  [PageId.PREPARE_PLAN_1]: PreparePlanAnatomyPage,
  [PageId.SCRATCH_ANATOMY_1]: ScratchAnatomy,
}

export const COMMUNICATION_PAGE_MAP_V1: TIdToPageMap = {
  [PageId.INTRO_COMMUNICATION_1]: IntroCommunicationPage,
  [PageId.GENDER_1]: GenderCommunicationPage,
  [PageId.AGE_1]: AgeCommunicationPage,
  [PageId.GOOD_COMPANY_1]: GoodCompanyCommunicationPage,
  [PageId.STUDY_GOAL_1]: StudyGoalCommunicationPage,
  [PageId.MOVING_FORWARD_COMMUNICATION_1]: MovingForwardCommunicationPage,
  [PageId.CONFIDENCE_1]: ConfidenceCommunicationPage,
  [PageId.STRUGGLE_COMMUNICATION_1]: StruggleCommunicationPage,
  [PageId.HOLDING_BACK_COMMUNICATION_1]: HoldingBackCommunicationPage,
  [PageId.REPLAY_COMMUNICATION_1]: ReplayCommunicationPage,
  [PageId.RATING_COMMUNICATION_1]: RatingCommunicationPage,
  [PageId.FILLER_COMMUNICATION_1]: FillerWordsCommunicationPage,
  [PageId.STATEMENT_COMMUNICATION_1]: StatementCommunicationPage,
  [PageId.SKILLS_CHART_COMMUNICATION_1]: SkillsChartCommunicationPage,
  [PageId.AUTHORITY_SKILLS_COMMUNICATION_1]: AuthoritySkillsCommunicationPage,
  [PageId.AUTHORITY_COMMUNICATION_1]: AuthorityCommunicationPage,
  [PageId.COMPARE_COMMUNICATION_1]: CompareCommunicationPage,
  [PageId.PERSONALITY_COMMUNICATION_1]: PersonalityCommunicationPage,
  [PageId.GROUP_CONVERSATION_COMMUNICATION_1]:
    GroupConversationCommunicationPage,
  [PageId.LIGHT_UP_COMMUNICATION_1]: LightUpCommunicationPage,
  [PageId.FEEDBACK_COMMUNICATION_1]: ConstructiveFeedbackCommunicationPage,
  [PageId.PLAN_READY_COMMUNICATION_1]: PlanReadyCommunicationPage,
  [PageId.ROLE_MODEL_COMMUNICATION_1]: RoleModelCommunicationPage,
  [PageId.MOTIVATION_COMMUNICATION_1]: MotivationCommunicationPage,
  [PageId.LEARNING_STYLE_COMMUNICATION_1]: LearningStyleCommunicationPage,
  [PageId.DAILY_GOAL_COMMUNICATION_1]: DailyGoalCommunicationPage,
  [PageId.PREPARE_PLAN_COMMUNICATION_1]: PreparePlanCommunicationPage,
  [PageId.BEFORE_AFTER_COMMUNICATION_1]: BeforeAfterCommunicationPage,
  [PageId.SCRATCH_COMMUNICATION_1]: ScratchCommunicationPage,
  [PageId.EMAIL_1]: EmailCommunicationPage,
}

export const ANATOMY_V2_PAGE_MAP_V1: TIdToPageMap = {
  [PageId.INTRO_ANATOMY_V2_1]: IntroAnatomyV2,
  [PageId.AGE_1]: AgeAnatomyV2,
  [PageId.GENDER_1]: GenderAnatomyV2,
  [PageId.BODY_PARTS_ANATOMY_V2_1]: BodyPartsAnatomyV2,
  [PageId.QUICK_EXPERIMENT_ANATOMY_V2_1]: QuickExperimentAnatomyV2,
  [PageId.QL_MUSCLE_REVEAL_ANATOMY_V2_1]: QlMuscleRevealAnatomyV2,
  [PageId.SPOT_THE_FAKE_ANATOMY_V2_1]: SpotTheFakeAnatomyV2,
  [PageId.SPINE_POSTURE_ANATOMY_V2_1]: SpinePostureAnatomyV2,
  [PageId.WATER_DIGESTION_ANATOMY_V2_1]: WaterDigestionAnatomyV2,
  [PageId.HIP_FLEXOR_ANATOMY_V2_1]: HipFlexorAnatomyV2,
  [PageId.SECTION_2_COMPLETE_ANATOMY_V2_1]: Section2CompleteAnatomyV2,
  [PageId.RATE_YOURSELF_ANATOMY_V2_1]: RateYourselfAnatomyV2,
  [PageId.STRONGEST_MUSCLE_ANATOMY_V2_1]: StrongestMuscleAnatomyV2,
  [PageId.SMALLEST_BONE_ANATOMY_V2_1]: SmallestBoneAnatomyV2,
  [PageId.ORGAN_REGENERATES_ANATOMY_V2_1]: OrganRegeneratesAnatomyV2,
  [PageId.POSTURE_INFLUENCE_ANATOMY_V2_1]: PostureInfluenceAnatomyV2,
  [PageId.SECTION_3_COMPLETE_ANATOMY_V2_1]: Section3CompleteAnatomyV2,
  [PageId.ANATOMY_NETWORK_ANATOMY_V2_1]: AnatomyNetworkAnatomyV2,
  [PageId.LOWER_BACK_PAIN_ANATOMY_V2_1]: LowerBackPainAnatomyV2,
  [PageId.NECK_STRAIN_ANATOMY_V2_1]: NeckStrainAnatomyV2,
  [PageId.SHOULDER_PAIN_ANATOMY_V2_1]: ShoulderPainAnatomyV2,
  [PageId.VAGUS_NERVE_ANATOMY_V2_1]: VagusNerveAnatomyV2,
  [PageId.SECTION_4_COMPLETE_ANATOMY_V2_1]: Section4CompleteAnatomyV2,
  [PageId.DIAGNOSIS_HEADACHE_ANATOMY_V2_1]: DiagnosisHeadacheAnatomyV2,
  [PageId.DIAGNOSIS_SHOULDER_ANATOMY_V2_1]: DiagnosisShoulderAnatomyV2,
  [PageId.DIAGNOSIS_HIP_ANATOMY_V2_1]: DiagnosisHipAnatomyV2,
  [PageId.SECTION_5_COMPLETE_ANATOMY_V2_1]: Section5CompleteAnatomyV2,
  [PageId.FOCUS_REVEAL_ANATOMY_V2_1]: FocusRevealAnatomyV2,
  [PageId.FOCUS_ABILITY_ANATOMY_V2_1]: FocusAbilityAnatomyV2,
  [PageId.FOCUS_GOAL_ANATOMY_V2_1]: FocusGoalAnatomyV2,
  [PageId.DOOMSCROLLING_TIME_ANATOMY_V2_1]: DoomscrollingTimeAnatomyV2,
  [PageId.YOU_RE_NOT_ALONE_ANATOMY_V2_1]: YoureNotAloneAnatomyV2,
  [PageId.KIND_OF_LEARNING_ANATOMY_V2_1]: KindOfLearningAnatomyV2,
  [PageId.SPECIFIC_REASON_ANATOMY_V2_1]: SpecificReasonAnatomyV2,
  [PageId.SOCIAL_PROOF_ANATOMY_V2_1]: SocialProofAnatomyV2,
  [PageId.DAILY_GOAL_ANATOMY_1]: DailyGoalAnatomy,
  [PageId.TOPICS_ANATOMY_1]: TopicsAnatomy,
  [PageId.EMAIL_1]: EmailAnatomy,
  [PageId.PREPARE_PLAN_1]: PreparePlanAnatomyPage,
  [PageId.LEARNING_PROFILE_ANATOMY_V2_1]: LearningProfileAnatomyV2,
  [PageId.WHAT_WE_EXPLORED_ANATOMY_V2_1]: WhatWeExploredAnatomyV2,
  [PageId.SCRATCH_ANATOMY_1]: ScratchAnatomy,
}

export const HISTORY_PAGE_MAP_V1: TIdToPageMap = {
  ...ANATOMY_PAGE_MAP_V1,
  [PageId.INTRO_PERSON_1]: IntroHistory,
  [PageId.STUDY_GOAL_1]: StudyGoal,
  [PageId.OUR_GOALS_1]: OurGoals,
  [PageId.ASPECTS_1]: Aspects,
  [PageId.TIME_TO_LEARN_1]: TimeToLearn,
  [PageId.LEARNING_AT_SCHOOL_1]: LearningAtSchool,
  [PageId.PRACTICAL_SKILLS_1]: PracticalSkills,
  [PageId.OSIRIS_1]: Osiris,
  [PageId.DISCOVERY_OF_AMERICA_1]: DiscoveryOfAmerica,
  [PageId.MUMMIES_1]: Mummies,
  [PageId.GREAT_JOB_1]: GreatJob,
  [PageId.STUDIED_BEFORE_1]: StudiedBefore,
  [PageId.RATE_YOUR_KNOWLEDGE_1]: RateYourKnowledge,
  [PageId.FRIENDLY_PUSH_1]: FriendlyPush,
  [PageId.INFORMATION_SOURCE_1]: InformationSource,
  [PageId.BEST_METHOD_1]: BestMethod,
  [PageId.CHURCHILL_1]: Churchill,
  [PageId.BERLIN_WALL_1]: BerlinWall,
  [PageId.AUTHOR_NAME_1]: AuthorName,
  [PageId.EXCELLENT_KNOWLEDGE_HISTORY_1]: ExcellentKnowledgeHistory,
  [PageId.MAKING_MISTAKES_1]: MakingMistakes,
  [PageId.BIGGEST_DISTRACTION_1]: BiggestDistraction,
  [PageId.STAYING_MOTIVATED_1]: StayingMotivated,
  [PageId.LEARNING_ABOUT_GEO_1]: LearningAboutGeo,
  [PageId.LIKE_MOST_1]: LikeMost,
  [PageId.GOOD_COMPANY_1]: GoodCompany,
  [PageId.SPECIFIC_REASON_HISTORY_1]: SpecificReasonHistory,
  [PageId.DAILY_GOAL_HISTORY_1]: DailyGoalAnatomy,
  [PageId.SCRATCH_HISTORY_1]: ScratchAnatomy,
  [PageId.PERSONAL_PLAN_1]: PersonalPlan,
}

export const ART_PAGE_MAP_V1: TIdToPageMap = {
  ...ANATOMY_PAGE_MAP_V1,
  [PageId.INTRO_ART_1]: IntroArt,
  [PageId.GOOD_COMPANY_1]: GoodCompanyArt,
  [PageId.FAMOUS_PAINTINGS_1]: FamousPaintings,
  [PageId.HIDDEN_DETAILS_1]: HiddenDetails,
  [PageId.WOW_FACTS_1]: WowFacts,
  [PageId.ART_BEYOND_PAINTINGS_1]: ArtBeyondPaintings,
  [PageId.INTERESTS_SHARED_1]: InterestsSharedArt,
  [PageId.STUDIED_BEFORE_ART_1]: StudiedBeforeArt,
  [PageId.RATE_YOUR_KNOWLEDGE_ART_1]: RateYourKnowledgeArt,
  [PageId.STUDY_GOAL_1]: StudyGoalArt,
  [PageId.OUR_GOALS_1]: OurGoalsArt,
  [PageId.STARRY_NIGHT_1]: StarryNight,
  [PageId.GIRL_PEARL_EARRING_1]: GirlPearlEarring,
  [PageId.PERSISTENCE_OF_MEMORY_1]: PersistenceOfMemory,
  [PageId.DAVID_SCULPTURE_1]: DavidSculpture,
  [PageId.ART_QUIZ_RESULT_1]: ArtQuizResult,
  [PageId.MONA_LISA_1]: MonaLisaArt,
  [PageId.THE_SCREAM_1]: TheScreamArt,
  [PageId.VAN_GOGH_EAR_1]: VanGoghEarArt,
  [PageId.LEARNING_IS_FUN_1]: LearningIsFunArt,
  [PageId.STATEMENT_ART_1]: StatementArt,
  [PageId.BEST_METHOD_ART_1]: BestMethodArt,
  [PageId.KIND_OF_LEARNING_ART_1]: KindOfLearningArt,
  [PageId.TOPICS_ART_1]: TopicsArt,
  [PageId.LEARNING_TIME_ART_1]: LearningTimeArt,
  [PageId.PERSONAL_PLAN_1]: PersonalPlanArt,
  [PageId.DAILY_GOAL_ART_1]: DailyGoalAnatomy,
  [PageId.SCRATCH_ART_1]: ScratchAnatomy,
}

export const GENERAL_PAGE_MAP_V1: TIdToPageMap = {
  ...ANATOMY_PAGE_MAP_V1,
  [PageId.INTRO_GENERAL_1]: IntroGeneral,
  [PageId.TOPICS_GENERAL_1]: Topics,
  [PageId.NARROW_TOPICS_GENERAL_1]: NarrowTopics,
  [PageId.TOPICS_CONFIRMATION_GENERAL_1]: TopicsConfirmation,
  [PageId.LEARNING_GOALS_GENERAL_1]: LearningGoals,
  [PageId.RATING_CONVERSATIONS_GENERAL_1]: RatingConversations,
  [PageId.RATING_PROCRASTINATION_GENERAL_1]: RatingProcrastination,
  [PageId.PACING_STATEMENT_GENERAL_1]: PacingStatement,
  [PageId.TOPIC_FACT_1_GENERAL_1]: TopicFact1,
  [PageId.TOPIC_FACT_2_GENERAL_1]: TopicFact2,
  [PageId.TOPIC_FACT_3_GENERAL_1]: TopicFact3,
  [PageId.TOPIC_FACT_4_GENERAL_1]: TopicFact4,
  [PageId.CREDIBILITY_GENERAL_1]: Credibility,
  [PageId.LEARNING_TIME_GENERAL_1]: LearningTime,
  [PageId.KIND_OF_LEARNING_GENERAL_1]: KindOfLearning,
  [PageId.MATCH_STYLE_GENERAL_1]: MatchStyle,
  [PageId.THINKING_STYLE_GENERAL_1]: ThinkingStyle,
  [PageId.RATING_VISUAL_GENERAL_1]: RatingVisual,
  [PageId.LEARNING_STYLE_STATEMENT_GENERAL_1]: LearningStyleStatement,
  [PageId.TESTS_FEELING_GENERAL_1]: TestsFeeling,
  [PageId.RATING_MISTAKES_GENERAL_1]: RatingMistakes,
  [PageId.CURIOSITY_STATEMENT_GENERAL_1]: CuriosityStatement,
  [PageId.LEARNING_OBSTACLE_GENERAL_1]: LearningObstacle,
  [PageId.FOCUS_ABILITY_GENERAL_1]: FocusAbility,
  [PageId.DOOMSCROLLING_TIME_GENERAL_1]: DoomscrollingTime,
  [PageId.SCREEN_TIME_STATEMENT_GENERAL_1]: ScreenTimeStatement,
  [PageId.RATING_LIFELONG_LEARNING_GENERAL_1]: RatingLifelongLearning,
  [PageId.SELF_GROWTH_REASON_GENERAL_1]: SelfGrowthReason,
  [PageId.REFERRAL_GENERAL_1]: Referral,
  [PageId.DAILY_GOAL_GENERAL_1]: DailyGoal,
  [PageId.PREPARE_PLAN_GENERAL_1]: PreparePlan,
  [PageId.PROOF_GENERAL_1]: Proof,
  [PageId.GOOD_COMPANY_1]: GoodCompanyGeneral,
  [PageId.EMAIL_1]: EmailGeneral,
  [PageId.LEARNING_PROFILE_GENERAL_1]: LearningProfile,
  [PageId.SCRATCH_GENERAL_1]: ScratchAnatomy,
}
